const widths = {
  widthGlobal: '576px',
  widthWideGlobal: '1100px',
};

export default widths;
